import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, ready } = useAuth();
    if (!ready) {
        return (
            <div className="min-h-screen flex items-center justify-center text-zinc-500">
                <span className="overline">Loading…</span>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
    return children;
}
